<template>
  <div class="edit-mortgage-properties">
    <a-collapse v-model="activeKey" v-if="this.mortgage">
      <a-collapse-panel v-for="mortgageProperty in mortgageProperties" :key="mortgageProperty.id + ''"
                        :header="mortgageProperty.property.data.description">
        <a-button slot="extra" type="danger" style="margin:-5px;"
                  v-on:click="handleDeleteClick(mortgageProperty)">
          <delete-icon/>
        </a-button>
        <MortgagePropertyEditComponent :mortgage-property-object="mortgageProperty"/>
      </a-collapse-panel>
    </a-collapse>

    <a-list v-model="activeKey" v-else-if="stateMortgageProperties !== null && stateMortgageProperties.length > 0">
      <a-list-item v-for="mortgageProperty in stateMortgageProperties" :key="mortgageProperty.id">
        {{ mortgageProperty.formatted_address }}
        <a-button slot="extra" type="danger" style="margin:-5px;"
                  v-on:click="handleDeleteClick(mortgageProperty)">
          <delete-icon/>
        </a-button>
      </a-list-item>
    </a-list>

    <a-button type="primary" v-on:click="handleShowMortgagePropertyCreate" class="create-button add-collateral-button">
      Onderpand toevoegen
    </a-button>

    <a-modal v-model="createModalVisible" title="Onderpand toevoegen" @cancel="handleCancelCreateMortgageProperty"
             @ok="handleCreateMortgageProperty" width="700" class="add-mortgage-property-modal">
      <div v-if="customerId">
        <h4>Klantadressen</h4>
        <div v-if="customerAssociatedProperties">
          <a-select style="width: 100%" @change="onCustomerAssociatedPropertySelected">
            <a-select-option v-for="(option, key) in customerAssociatedProperties" :key="key">
              {{ option.formatted_address }}
            </a-select-option>
          </a-select>
        </div>
        <div v-else>Er zijn nog geen adressen aan deze klant gekoppeld</div>
        <h4 style="margin-top: 2rem">Adres zoeken</h4>
      </div>
      <PropertySearchOrCreateByAddressComponent v-on:property-selected="onPropertySelected" style="margin-bottom: 15px;"/>
      <div v-if="hasSelectedProperty">
        <p><b>Geselecteerde pand</b></p>
        {{ selectedProperty.description }}
      </div>
    </a-modal>
  </div>
</template>

<script>
import ManualCreateComponent from "~/modules/property/components/ManualCreateComponent";
import mortgageApi from "~/api/mortgage"
import mortgagePropertyApi from "~/api/mortgage_property"
import MortgagePropertyEditComponent from '~/modules/mortgage_property/components/EditComponent'
import propertyApi from "~/api/property"
import PropertySearchOrCreateByAddressComponent from "../../property/components/SearchOrCreateByAddressComponent";
import { mapState, mapMutations } from "vuex";


export default {
  name: "MortgageEditMortgagePropertiesComponent",
  components: {
    MortgagePropertyEditComponent,
    PropertySearchOrCreateByAddressComponent,
    ManualCreateComponent
  },
  props: {
    mortgageId: {
      required: false,
      default: null
    },
    mortgageProp: {
      type: Object,
      required: false,
      default: null
    },
    customerId: {
      type: [Number, String],
      required: false,
      default: null,
    }
  },
  data() {
    return {
      mortgageProperties: [],
      activeKey: [],
      createModalVisible: false,
      selectedProperty: null,
      customerAssociatedProperties: null,
      mortgage: null
    };
  },
  mounted() {
    if (this.mortgageProp !== null && this.mortgageId !== null) {
      throw new Error('Either give a mortgageProp or a mortgageId, not both.');
    }

    if (this.mortgageId !== null) {
      mortgageApi.find(this.mortgageId).then(response => {
        this.mortgage = response.data;
        this.initMortgageProperties();
      });
    } else if (this.mortgageProp !== null) {
      this.mortgage = this.mortgageProp;
      this.initMortgageProperties();
    } else {
      this.mortgageProperties = [];
    }

    if (this.customerId !== null) {
      propertyApi.getPropertiesAssociatedWithCustomer(this.customerId).then(response => {
        this.customerAssociatedProperties = response.data
      })
    }
  },
  computed: {
    hasSelectedProperty() {
      return this.selectedProperty !== null;
    },
    getMortgageProperties() {
      if (this.mortgage) {
        return this.mortgageProperties;
      } else {
        return this.stateMortgageProperties;
      }
    },
    ...mapState('mortgage', {
      stateMortgageProperties: 'mortgageProperties'
    })
  },
  methods: {
    initMortgageProperties() {
      mortgagePropertyApi.paginateByMortgage(this.mortgage.id, 1, 50, [
          'property', 'property.valuations'
      ]).then(response => {
        this.mortgageProperties = response.data;

        if (typeof this.mortgageProperties[0] !== "undefined") {
          this.activeKey = [this.mortgageProperties[0].id + ''];
        }
      });
    },
    handleDeleteClick(mortgageProperty) {
      event.stopPropagation();

      this.$confirm({
        title: 'Onderpand ontkoppelen',
        content: 'Weet je zeker dat je dit pand als onderpand wil ontkoppelen van de hypotheek?',
        okText: 'Ja',
        cancelText: 'Annuleren',
        onOk: () => {
          if (this.mortgage) {
            mortgagePropertyApi.delete(mortgageProperty.id).then(response => {
              this.mortgageProperties = this.mortgageProperties.filter(item => {
                return item.id !== mortgageProperty.id;
              })
            });
          } else {
            this.stateMortgageProperties.splice(this.stateMortgageProperties.find(property => property.id === mortgageProperty.id), 1);
          }
        },
        onCancel() {
        },
      });
    },
    handleShowMortgagePropertyCreate() {
      this.selectedProperty = null;
      this.createModalVisible = true;
    },
    onPropertySelected(property) {
      this.selectedProperty = property;
    },
    onCustomerAssociatedPropertySelected(key) {
      this.selectedProperty = this.customerAssociatedProperties[key];
    },
    handleCreateMortgageProperty() {
      return new Promise((resolve, reject) => {
        if (!this.hasSelectedProperty) {
          this.$message.warning('Selecteer eerst een pand');
          reject();
        }

        if (!this.mortgage) {
          this.stateMortgageProperties.push(this.selectedProperty);
          this.createModalVisible = false;
          resolve();
        }

        mortgagePropertyApi.create({
          mortgage_id: this.mortgage.id,
          property_id: this.selectedProperty.id,
        }).then(() => {
          this.createModalVisible = false;
          this.initMortgageProperties();
          resolve();
        }).catch(error => {
          let errorResponse = error.response.data;
          if (errorResponse.error && errorResponse.error.errors) {
            for (let attribute in errorResponse.error.errors) {
              let errors = errorResponse.error.errors[attribute];
              errors.forEach(error => {
                this.$notification['error']({
                  message: 'Er ging iets mis',
                  description: error,
                });
              })
            }
          }
          reject();
        });
      });
    },
    handleCancelCreateMortgageProperty() {
      this.createModalVisible = false;
    },
    ...mapMutations('mortgage',[
        'addMortgageProperty',
        'removeMortgageProperty'
    ])
  }
}
</script>
<style scoped>
.edit-mortgage-properties {
  position: relative;
  margin-bottom: 15px;
}

.create-button {
  margin-top: 15px;
}
</style>
